/**
 * My Account Block - Frontend Script
 */

document.addEventListener('DOMContentLoaded', function() {
	const portalButtons = document.querySelectorAll('.xtra-my-account__portal-button');
	
	portalButtons.forEach(button => {
		button.addEventListener('click', async function(e) {
			const customerId = this.dataset.customerId;
			
			// Only handle Stripe portal buttons (with customer ID)
			// Let regular links work normally
			if (!customerId) {
				return;
			}
			
			e.preventDefault();
			
			// Disable button and show loading state
			const originalText = this.textContent;
			this.disabled = true;
			this.textContent = 'Loading...';
			
			try {
				// Call REST API to create portal session
				const response = await fetch('/wp-json/xtraxtra-stripe/v1/create-portal-session', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-WP-Nonce': xtraxtraBlocks.nonce
					},
					body: JSON.stringify({
						customer_id: customerId,
						return_url: window.location.href
					})
				});
				
				if (!response.ok) {
					throw new Error('Failed to create portal session');
				}
				
				const data = await response.json();
				
				if (data.url) {
					// Redirect to Stripe customer portal
					window.location.href = data.url;
				} else {
					throw new Error('No portal URL received');
				}
			} catch (error) {
				console.error('Error creating portal session:', error);
				alert('Unable to access the customer portal. Please try again later.');
				
				// Re-enable button
				this.disabled = false;
				this.textContent = originalText;
			}
		});
	});
});